import { useEffect, useState } from 'react';
import { getOrCreateAnonymousUser } from '../db/repository';
import type { User } from '../db/types';

/**
 * Returns the current anonymous (or upgraded) user for this device.
 * Created on first call; cached across the app lifetime.
 */
export function useUser(): {
  user: User | null;
  loading: boolean;
  error: Error | null;
} {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getOrCreateAnonymousUser()
      .then((u) => {
        if (!cancelled) setUser(u);
      })
      .catch((e: Error) => {
        if (!cancelled) setError(e);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { user, loading, error };
}
